import {useRef,useMemo} from "react";
import TankDetailBatchPopup from './TankDetailBatchPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';

const TankDetailBatches=({parentId,application,userData,parent})=>{
    const list_name='tank_batches';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'Batch'}
                entityParams={['tank_id='+parentId,'_context='+['parent_name=Tank'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'TankDetailBatches.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={TankDetailBatchPopup}
                parentContext={{
                    parent_field_name:'tank_id',
                    parent_field_value:null,
                    parent_name:'Tank'
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default TankDetailBatches;
